var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center mt-5"},[_c('p',[_vm._v("Connecting your Stripe account...")])])
}]

export { render, staticRenderFns }